/**
 * agreements.service.ts — Layer 3: Agreements / Templates Domain
 */

import { getRequest, deleteRequest, patchRequest, postFormData, putFormData } from './http.service';
import {
  URL_AGREEMENTS_BY_ORG,
  URL_AGREEMENTS_UPLOAD,
  URL_AGREEMENT_BY_ID,
  URL_AGREEMENT_MARK_READY,
} from './url.service';

/** List all agreements for an org */
export const fetchAgreements = (orgId: string) =>
  getRequest(URL_AGREEMENTS_BY_ORG(orgId));

/** Upload a new agreement template (PDF) */
export const uploadAgreement = (formData: FormData) =>
  postFormData(URL_AGREEMENTS_UPLOAD, formData);

/** Replace an existing agreement file */
export const updateAgreement = (agreementId: string, formData: FormData) =>
  putFormData(URL_AGREEMENT_BY_ID(agreementId), formData);

/** Delete an agreement */
export const deleteAgreement = (agreementId: string) =>
  deleteRequest(URL_AGREEMENT_BY_ID(agreementId));

/** Mark a configured agreement template as ready to use */
export const markAgreementReady = (agreementId: string) =>
  patchRequest(URL_AGREEMENT_MARK_READY(agreementId), {});
